<template>
    <CModal
            :title="title"
            :color="color"
            :show="getOpen"
    >
        {{ text }}
        <template #footer>
            <CButton @click="close" :color="color">Schliessen</CButton>
        </template>
    </CModal>
</template>

<script>
    export default {
        name: "DeleteModal",
        props: {
            open: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String
            },
            text: {
                type: String
            },
            color: {
                type: String,
                default: 'danger'
            },
            user: {
                type: String
            }
        },

        computed: {
            getOpen() {
                return this.open
            },

            close() {
                this.open
            }

        }
    }
</script>

<style scoped>

</style>
